import React from 'react'
import Navbar from '../components/navbar/navbar'
import Footer from '../components/footer/footer'

function Contact1() {
  return (
    <>
     <Navbar />
     <h1 className='hw'>Welcome to Dubu</h1>
     <p className='center'><a>Copy The Link</a></p>
    <Footer />
    </>
  )
}

export default Contact1;
